

















import {
  Component,
  Prop,
  Watch,
  Vue,
  Emit
} from 'vue-property-decorator';

@Component({
  components: {

  },
})
export default class LabelProcessing extends Vue {

  @Prop({ default: ()=> 'primary' }) 
  type: string;

  @Prop({ default: ()=> true }) 
  processing: boolean;


}
